import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { CapacityPlannerScreen } from '../../screen/CapacityPlanner/Screen';
import { projectColor, userColor, getStartOfWeek } from './types';

interface Props { planner: CapacityPlannerScreen; }

@observer
export class AllocationEditor extends React.Component<Props> {
    render() {
        const p = this.props.planner;
        if (!p.allocationEditorOpen || !p.editingAllocation) return null;
        const { projectId, developerId } = p.editingAllocation;
        const proj = p.projects.find(pr => pr.id === projectId) as any;
        const dev = p.users.find(u => u.id === developerId) as any;
        if (!proj || !dev) return null;
        return (
            <div className="cp-modal" data-test-cp-allocation-editor onClick={(e) => { if (e.target === e.currentTarget) p.closeAllocationEditor(); }}>
                <div className="cp-modal-content allocation-editor">
                    <h3>Edit Allocation</h3>
                    <div className="allocation-info">
                        <div className="allocation-dev">
                            <div className="dev-avatar" style={{ background: userColor(dev) }}>{(dev.fullName || '?').charAt(0)}</div>
                            <span>{dev.fullName}</span>
                        </div>
                        <div className="allocation-project">
                            <div className="project-color" style={{ background: projectColor(proj) }} />
                            <span>{proj.name}</span>
                        </div>
                    </div>
                    <div className="allocation-periods">
                        {p.editingPeriods.map((period, idx) => (
                            <div key={idx} className="allocation-period">
                                {idx > 0 && <button className="delete-period" onClick={() => p.deleteAllocationPeriod(idx)}>&times;</button>}
                                <div className="period-header">
                                    <label>{idx === 0 ? 'Starting from:' : 'Change starting:'}</label>
                                    <input type="date" value={moment(period.weekStart).format('YYYY-MM-DD')}
                                        onChange={(e) => { period.weekStart = getStartOfWeek(new Date(e.target.value)); p.editingPeriods.sort((a, b) => new Date(a.weekStart).getTime() - new Date(b.weekStart).getTime()); }}
                                        disabled={idx === 0} />
                                </div>
                                <div className="days-selector">
                                    {(['mon', 'tue', 'wed', 'thu', 'fri'] as const).map(day => {
                                        const isSelected = period.days.includes(day);
                                        const devHours = p.getDevHoursPerDay(dev)[day];
                                        const isDisabled = devHours === 0;
                                        return (
                                            <button key={day} type="button"
                                                className={'day-toggle' + (isSelected ? ' selected' : '') + (isDisabled ? ' disabled' : '')}
                                                onClick={() => !isDisabled && p.toggleAllocationDay(idx, day)}
                                                disabled={isDisabled}
                                                title={isDisabled ? 'Dev does not work this day' : ''}>
                                                {day.charAt(0).toUpperCase() + day.slice(1, 3)}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="btn btn-sm btn-secondary" style={{ marginTop: '1rem' }} onClick={p.addAllocationPeriod}>+ Add New Period</button>
                    <div className="cp-modal-actions">
                        <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={p.removeAllocation}>Remove from Project</button>
                        <button className="btn btn-secondary" onClick={p.closeAllocationEditor}>Cancel</button>
                        <button className="btn btn-primary" onClick={p.saveAllocation}>Save</button>
                    </div>
                </div>
            </div>
        );
    }
}
